import { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import { FaLink } from "react-icons/fa";
import TimelineItem from "examples/Timeline/TimelineItem";
import palette from "assets/theme/base/colors";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { api } from "../../../../services/api"; // Importando o serviço de API

function OrdersOverview({ isLoading }) {
  const [sourceLinks, setSourceLinks] = useState([]);

  useEffect(() => {
    if (!isLoading) {
      const fetchSourceLinks = async () => {
        try {
          const data = await api.get(`/source-links`);
          setSourceLinks(data);
        } catch (error) {
          console.error("Erro ao buscar os links de origem:", error);
        }
      };

      fetchSourceLinks();
    }
  }, [isLoading]);

  const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + "...";
    }
    return text;
  };

  const skeletonItems = [...Array(5)].map((_, i) => (
    <TimelineItem
      key={i}
      icon={<Skeleton circle width={16} height={16} />}
      title="Carregando..."
      dateTime="Carregando..."
    />
  ));

  return (
    <Card className="h-100">
      <VuiBox mb="16px">
        <VuiTypography variant="lg" fontWeight="bold" mb="5px" color="white">
          {isLoading ? <Skeleton width={150} /> : "Links de Origem"}
        </VuiTypography>
        <VuiBox mb={2}>
          <VuiTypography variant="button" color="text" fontWeight="regular">
            {isLoading ? <Skeleton count={2} /> : "Links com maior número de fraudadores associados."}
          </VuiTypography>
        </VuiBox>
      </VuiBox>
      <VuiBox>
        {isLoading ? skeletonItems : (
          sourceLinks.length > 0 ? (
            sourceLinks.map((link, index) => (
              <TimelineItem
                key={index}
                icon={<FaLink size="16px" color={palette.info.main} />}
                title={truncateText(link.source_url, 50)}
                dateTime={`Fraudadores: ${link.fraudster_count}`}
              />
            ))
          ) : (
            <VuiTypography variant="button" color="text" fontWeight="regular">
              Nenhum link de origem encontrado.
            </VuiTypography>
          )
        )}
      </VuiBox>
    </Card>
  );
}

export default OrdersOverview;